(function(){
    'use strict';
    angular.module('Directives').directive('bbaDriversList', bbaDriversList);
    bbaDriversList.$inject = [
        'FleetService',
        'toastr',
        '$q',
        '$filter'
    ];

    function bbaDriversList(
        FleetService,
        toastr,
        $q,
        $filter
    ){
        return {
            restrict: 'E', 
            templateUrl: '/templates/directives/components/driver-chat/bbaDriversList.html',
            scope: {
                newMessage: '=',
                selectDriverCallback: '=',
                updateNewMsgNotif: '='
            }, 
            link: bbaDriversListLink
        }

        function bbaDriversListLink(scope, elmems, attrs) {
            scope.showPanelBody = false;
            scope.togglePanel = togglePanel; 
            scope.searchDriver = searchDriver;

            init();

            function init(){
                scope.$watch('newMessage', function(newMsg){
                    scope.storedNewMsg = JSON.parse(localStorage.getItem('new-messages')); 
                    loadAllDrivers(false);
                });

                scope.$watch('updateNewMsgNotif', function(data){ 
                    if(data) {
                        scope.storedNewMsg = JSON.parse(localStorage.getItem('new-messages')); 
                        const newMsgsIds = scope.storedNewMsg ? scope.storedNewMsg.map(msg=>{
                            return msg.jobId;
                        }) : [];
                        scope.driversListData = updateNewMsgIndicator(scope.driversListData, newMsgsIds); 
                    }
                });
            }

            function updateNewMsgIndicator(data, newMsgs){
                for(let i = 0; i < data.length; i++) {
                    data[i].newMsg = 0;
                    for(let x = 0; x < newMsgs.length; x++) {
                        const id = newMsgs[i];
                        if(id == data[i].jobId){
                            data[i].newMsg += 1;
                        }
                    }
                }
                return data;
            }

            function togglePanel(){
                scope.showPanelBody = !scope.showPanelBody;
            }

            function searchDriver(driverName){
                if(driverName != "") {
                    scope.loading = true;
                    loadDriversData({fullName: driverName}).then(data=>{
                        console.log(data);
                        scope.driversListData = data.map(driver=>{
                            return {
                                avatar: driver.driverPhotoUrl, 
                                name: `${driver.firstName} ${driver.lastName}`, 
                                driverId: driver.id, 
                                active: driver.active,   
                                newMsg: driver.newMsg
                            }
                        });
                        scope.loading = false;
                    });
                }
                else {
                    loadAllDrivers();
                }
            }

            function loadAllDrivers(showLoading = true){
                scope.loading = showLoading;
                $q.all({
                    driverWithNewMsgs: loadDriversThatHasNewMsgs(), 
                    allDrivers: loadDriversData()
                }).then(function(res){
                    let drivers = res.driverWithNewMsgs.length !== 0 ?  $filter('removeDuplicatedDrivers')(res.driverWithNewMsgs.concat(res.allDrivers)) : res.allDrivers;
                    scope.driversListData = drivers.map(driver => {
                        return {
                            avatar: driver.driverPhotoUrl, 
                            name: `${driver.firstName} ${driver.lastName}`, 
                            driverId: driver.id, 
                            active: driver.active,   
                            newMsg: driver.newMsg
                        }
                    });
                    scope.loading = false;
                }, error => {
                    console.log(error);
                    scope.loading = false;
                });
            }

            function loadDriversData(filters = {}){
                const deffered = $q.defer();
                filters.active = true;
                FleetService.Drivers.getAll(data => {
                    deffered.resolve(data.content);
                }, err => {
                    console.log(error);
                    toastr.error('Unable to load drivers', err.message);
                    deffered.reject(error)
                }, angular.extend({
                    size: 10,
                    sort: 'id,asc'
                }, filters));
                return deffered.promise;
            }

            function loadDriversThatHasNewMsgs(){
                const deffered = $q.defer();
                const storedMsg = JSON.parse(localStorage.getItem('new-messages')); 

                if(storedMsg) {
                    if(storedMsg.length != 0) {
                        const jobIds = storedMsg.map(data => {
                            return data.jobId;
                        });
                        const filters = {id: jobIds};

                        FleetService.Chat.jobs(data=>{
                            const drivers  = addMarkerToDriver(data.content, jobIds).map(job=> {
                                return job.driver;
                            });
                            deffered.resolve(drivers);
                        }, error=>{
                            deffered.reject(error);
                            toastr.error(error.message, 'Error');
                        }, angular.extend({
                            size: 10, 
                            sort: 'id,asc'
                        }, filters));
                    } else {
                        deffered.resolve([]);
                    }
                }
                else {
                    deffered.resolve([]);
                }
                return deffered.promise;
            }

            function addMarkerToDriver(data, newMsgs){
                for(let i = 0; i < data.length; i++) {
                    data[i].driver.newMsg = 0;
                    for(let x = 0; x < newMsgs.length; x++) {
                        const id = newMsgs[i];
                        if(id == data[i].id){
                            data[i].driver.newMsg += 1;
                            data[i].driver.jobId = newMsgs[i];
                        }
                    }
                }
                return data;
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/component/driver-chat/bbaDriversList.js